module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "catalog-forecast-market-container"
  }, [(_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": _vm.loading,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mb-4"
  }, [(_vm.periodHasZones.length && _vm.selectedPeriod) ? _c('div', {
    staticClass: "col-12 d-flex align-items-center catalog-forecast-market-container-periods mb-5"
  }, [(_vm.periodHasZones.length > 8) ? _c('div', {
    staticClass: "col-auto",
    class: {
      'disable-arrow': _vm.offsetControl === 0
    },
    on: {
      "click": function($event) {
        _vm.updateOffset(-1)
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.periodHasZones), function(pz, index) {
    return (index >= _vm.offsetControl && index < _vm.offsetControl + 8) ? _c('div', {
      key: index,
      staticClass: "col"
    }, [_c('span', {
      class: (_vm.selectedPeriod.id === pz.period.id ? ' active ' : ' ') + (pz.period.isOpened ? ' open ' : ' '),
      on: {
        "click": function($event) {
          _vm.changePeriod(pz)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDate(pz.period.stampCode, "MMM YY", "second")) + "\n                ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.periodHasZones.length > 8) ? _c('div', {
    staticClass: "col-auto",
    class: {
      'disable-arrow': _vm.offsetControl === _vm.periodHasZones.length - 8
    },
    on: {
      "click": function($event) {
        _vm.updateOffset(1)
      }
    }
  }, [_vm._m(1)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin() || _vm.hasAccessByProfile(_vm.PROFILES.COORDINATOR, _vm.APPLICATION.CATALOG_FORECAST_ID)) ? _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.goToDashboard()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("catalogForecast.market.backToDashboard")) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.periodHasZone && _vm.selectedPeriod) ? _c('div', [_c('div', {
    staticClass: "row catalog-forecast-market-container-header d-flex align-items-end mb-4"
  }, [_c('div', {
    staticClass: "col-12 col-xl"
  }, [_c('p', {
    staticClass: "title mb-2"
  }, [_vm._v(_vm._s(_vm.periodHasZone.zone.name.toUpperCase()))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle mb-5"
  }, [_vm._v(_vm._s(_vm.periodTitle))]), _vm._v(" "), _c('PeriodDates', {
    attrs: {
      "period": _vm.selectedPeriod
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col d-flex justify-content-end mt-4 mt-xl-0"
  }, [_c('div', [(_vm.periodHasZone.status === _vm.PERIOD_STATUS.RECHALLENGED) ? _c('div', {
    staticClass: "mb-5 rechallenged d-flex align-items-center"
  }, [_c('span', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.$t('catalogForecast.market.rechallenged')),
      expression: "$t('catalogForecast.market.rechallenged')"
    }],
    staticClass: "mr-3"
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "size": "m",
      "rounded100": true,
      "background-color": "#F9C53C",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.openModalRechallengeInfos()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo-alt fa-lg"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('ClientColorButton', {
    staticClass: "mr-5",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.checkDownload()
      }
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.$t("common.download")))]), _vm._v(" "), _c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../../../static/img/logo-xls.svg")
    }
  })]), _vm._v(" "), (_vm.paramsModalDownloadInfos) ? _c('DownloadInfos', {
    attrs: {
      "params": _vm.paramsModalDownloadInfos
    },
    on: {
      "yes": function($event) {
        _vm.download()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canFirmorderUpdate || _vm.canForecastUpdate) ? _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.checkUpload
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.$t("common.upload")))]), _vm._v(" "), _c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../../../static/img/logo-xls.svg")
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "uploadTemplate",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": function($event) {
        _vm.changeUploadFile()
      }
    }
  }), _vm._v(" "), (_vm.paramsModalUploadInfos) ? _c('UploadInfos', {
    attrs: {
      "params": _vm.paramsModalUploadInfos
    },
    on: {
      "yes": function($event) {
        _vm.openUploadFileExplorer()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [(_vm.canFirmorderUpdate || _vm.canForecastUpdate) ? _c('div', [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "rounded": true,
      "background-color": "#80D837"
    },
    on: {
      "click": function($event) {
        _vm.save(_vm.PERIOD_STATUS.STARTED)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("common.save")) + "\n                            ")]), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "mr-5",
    attrs: {
      "rounded": true,
      "background-color": "#80D837"
    },
    on: {
      "click": function($event) {
        _vm.save(_vm.PERIOD_STATUS.SUBMITTED)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("catalogForecast.market.saveAndSubmit")) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), _c('History', {
    attrs: {
      "is-dark": false,
      "object-type": _vm.OBJECT_TYPE.PERIOD_HAS_ZONES,
      "object": _vm.periodHasZone,
      "name": _vm.periodHasZone.zone.name.toUpperCase() + ' - ' + _vm.periodTitle
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row catalog-forecast-market-container-search d-flex align-items-start"
  }, [_c('div', {
    staticClass: "col-auto mt-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.searchItem")))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "rem3rch-input-text",
    attrs: {
      "type": "text",
      "id": "searchBySearch"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value.trim()
      }, _vm.debounceSearch],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl mt-3 mr-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.searchByCategory")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.categoriesLevelSelected), function(categoriesLevel, index) {
    return _c('div', {
      key: index,
      staticClass: "col-auto mb-3"
    }, [(_vm.categoriesLevelSelected[index]) ? _c('Multiselect', {
      attrs: {
        "options": _vm.categoriesLevelSelected[index],
        "label": "name",
        "track-by": "id",
        "multiple": false,
        "select-label": '',
        "close-on-select": true,
        "show-labels": true,
        "placeholder": _vm.$t('catalogForecast.market.selectCategory') + ' ' + (index + 1),
        "deselect-label": _vm.$t('common.delete')
      },
      on: {
        "input": function($event) {
          _vm.updateCategory($event, index)
        }
      },
      model: {
        value: (_vm.categoriesSelected[index]),
        callback: function($$v) {
          _vm.$set(_vm.categoriesSelected, index, $$v)
        },
        expression: "categoriesSelected[index]"
      }
    }) : _vm._e()], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "catalog-forecast-market-container-table mt-5"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "count-reference"
  }, [_vm._v(_vm._s(_vm.periodHasComponentsPagination.totalItems) + "\n                        " + _vm._s(_vm.$t("catalogForecast.market.reference" + (_vm.periodHasComponentsPagination.totalItems > 1 ? "s" : ""))))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('DefaultPagination', {
    attrs: {
      "item-pagination": _vm.periodHasComponentsPagination,
      "offset": _vm.offset
    },
    on: {
      "change": _vm.changeOffset
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "table-column"
  }, [_c('table', {
    ref: "table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sap"
  }, [_vm._v("SAP")]), _vm._v(" "), _c('th', {
    staticClass: "ean"
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.nameLabel")))]), _vm._v(" "), _c('th', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.unitLabel")))]), _vm._v(" "), _c('th', {
    staticClass: "info"
  }, [_vm._v("INFO")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.periodHasComponents), function(periodHasComponent) {
    return [_c('tr', {
      key: periodHasComponent.id
    }, [_c('td', {
      staticClass: "sap"
    }, [_vm._v(_vm._s(periodHasComponent.component.codeSap))]), _vm._v(" "), _c('td', {
      staticClass: "ean"
    }, [_vm._v(_vm._s(periodHasComponent.component.codeEan))]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: (periodHasComponent.component.CPTR_name),
        expression: "periodHasComponent.component.CPTR_name",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }, {
        name: "b-tooltip",
        rawName: "v-b-tooltip.disabled",
        value: (_vm.disableTooltip('name' + periodHasComponent.component.cpntId)),
        expression: "disableTooltip('name' + periodHasComponent.component.cpntId)",
        modifiers: {
          "disabled": true
        }
      }],
      ref: 'name' + periodHasComponent.component.cpntId,
      refInFor: true,
      attrs: {
        "id": 'name' + periodHasComponent.component.cpntId
      }
    }, [_vm._v("\n                                            " + _vm._s(periodHasComponent.component.CPTR_name) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "unit text-center"
    }, [_vm._v("\n                                        " + _vm._s(periodHasComponent.component.unitPerBox ? periodHasComponent.component.unitPerBox : "-") + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.openModalComponentInfos(periodHasComponent)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle fa-lg"
    })])])])]
  }), _vm._v(" "), (!_vm.periodHasComponents || !_vm.periodHasComponents.length) ? _c('tr', {
    staticClass: "notfound"
  }, [_c('td', {
    attrs: {
      "colspan": 5
    }
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.noItem")))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-column table-responsive"
  }, [_c('table', {
    ref: "table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columnsFiltered), function(column) {
    return (_vm.columnsFiltered.length) ? [_c('th', {
      key: column.id,
      staticClass: "header",
      class: column.firmorder ? 'firmorder' : 'forecast'
    }, [_c('div', {
      staticClass: "d-flex align-items-start flex-column"
    }, [_c('span', [_vm._v(_vm._s(column.firmorder ? "firmorder" : "forecast"))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: (_vm.getHeaderLabel(column)),
        expression: "getHeaderLabel(column)"
      }]
    })])])] : _vm._e()
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.periodHasComponents), function(periodHasComponent) {
    return [_c('tr', {
      key: periodHasComponent.id
    }, [_vm._l((_vm.columnsFiltered), function(column) {
      return (_vm.columnsFiltered.length) ? [_c('td', {
        key: column.id,
        class: (!_vm.isCatalogComponent(periodHasComponent.component, column) ||
          !_vm.isActiveComponent(periodHasComponent.component) ||
          _vm.isDolceGabbana2023(column) ?
          'not-active ' :
          ' ') + (column.firmorder ? 'firmorder' : 'forecast'),
        on: {
          "click": function($event) {
            _vm.focusInput(("input_" + (periodHasComponent.id) + "_" + (column.id)))
          }
        }
      }, [_c('input', {
        directives: [{
          name: "digitsonly",
          rawName: "v-digitsonly"
        }],
        ref: ("input_" + (periodHasComponent.id) + "_" + (column.id)),
        refInFor: true,
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "id": ("input_" + (periodHasComponent.id) + "_" + (column.id)),
          "readonly": !_vm.canCellUpdate(
            column.firmorder ? _vm.canFirmorderUpdate : _vm.canForecastUpdate,
            periodHasComponent.component,
            column
          )
        },
        domProps: {
          "value": _vm.getComponentQuantity(column, periodHasComponent.id)
        },
        on: {
          "keydown": function($event) {
            _vm.tab($event, ("input_" + (periodHasComponent.id) + "_" + (column.id)), _vm.columnsFiltered.length)
          },
          "input": function($event) {
            _vm.updateFirmorderQuantity($event, column, periodHasComponent)
          }
        }
      })])] : _vm._e()
    })], 2)]
  }), _vm._v(" "), (!_vm.periodHasComponents || !_vm.periodHasComponents.length) ? _c('tr', {
    staticClass: "notfound"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.columnsFiltered.length
    }
  })]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "count-reference"
  }, [_vm._v(_vm._s(_vm.periodHasComponentsPagination.totalItems) + "\n                        " + _vm._s(_vm.$t("catalogForecast.market.reference" + (_vm.periodHasComponentsPagination.totalItems > 1 ? "s" : ""))))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('DefaultPagination', {
    staticClass: "mb-4",
    attrs: {
      "item-pagination": _vm.periodHasComponentsPagination,
      "offset": _vm.offset
    },
    on: {
      "change": _vm.changeOffset
    }
  })], 1)]), _vm._v(" "), (_vm.paramsModalRechallengeInfos) ? _c('RechallengeInfos', {
    attrs: {
      "params": _vm.paramsModalRechallengeInfos
    },
    on: {
      "close": function($event) {
        _vm.paramsModalRechallengeInfos = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.paramsModalComponentInfos) ? _c('ComponentInfos', {
    attrs: {
      "params": _vm.paramsModalComponentInfos
    },
    on: {
      "close": function($event) {
        _vm.paramsModalComponentInfos = null
      }
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "m-0 pointer ml-3 mr-5",
    attrs: {
      "for": "searchBySearch"
    }
  }, [_c('i', {
    staticClass: "fa fa-search fa-lg color-grey"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4beb56fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/elements/CatalogForecastMarket.vue
// module id = 3168
// module chunks = 0